import { MensajePeticionGestionGlosas, RespuestaGestionGlosas } from "./GlosaEmpleador";
import fileDownload from "js-file-download";
import * as moment from "moment";
import { TransaccionSat } from "../../../general/modelo/TransaccionSat";
import { cabeceraRespuestaGestionGlosas, LibroDocumentoXLS, TIPO_GLOSA_SAT } from "../../../general/modelo/PlanillasXLS";
import { crearPlantillaXLS } from "../../../general/componentes/GenerarPlantillaXLS";
import { obtenerProcesoGestion } from "./TiposProcesosGestion";

export const generarXLSRespuestaGestionGlosas = (listaRespuesta: Array<RespuestaGestionGlosas>, transaccionesSat: Array<TransaccionSat>, esAfiliacionTraslado: boolean) => {
    const tipoGlosa = esAfiliacionTraslado ? TIPO_GLOSA_SAT.AFILIACIONES : TIPO_GLOSA_SAT.NOVEDADES;
    const excelBlob: Blob = construirXLS(listaRespuesta, transaccionesSat, tipoGlosa);
    const nombreArchivo = `reporte_sat_${moment(moment.now()).format("DD_MM_YYYY_HHmmss")}.xlsx`;
    fileDownload(
        excelBlob,
        nombreArchivo,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
};

const construirXLS =(listaRespuesta: Array<RespuestaGestionGlosas>, transaccionesSat: Array<TransaccionSat>, tipoGlosa: TIPO_GLOSA_SAT) => {
    /*Libros a generar en el XLS*/
    const libroGlosas = 'Error Glosas Gestionadas';
    const librosXLS = [libroGlosas];

    /*Datos para el libro de Glosas*/
    const datosGlosas = listaRespuesta.filter((respuesta: RespuestaGestionGlosas) => !respuesta.exitoGestion).map(
        (respuestaGlosaGestion: RespuestaGestionGlosas) => {
            const datosServicio = transaccionesSat.find(
                transaccion => transaccion.codigo.toString() === respuestaGlosaGestion.glosaEmpleador.codigoServicio.toString()
            );
            const glosaEmpleador = respuestaGlosaGestion.glosaEmpleador;
            const mensajePeticion: MensajePeticionGestionGlosas = {
                codigoServicio: glosaEmpleador.codigoServicio,
                consecutivo: glosaEmpleador.consecutivo,
                codigoProceso: respuestaGlosaGestion.codigoProceso,
                dniModifica: respuestaGlosaGestion.dniUsuarioGestion,
                observacion: respuestaGlosaGestion.observacionGestion
            };
            if(tipoGlosa === TIPO_GLOSA_SAT.NOVEDADES) {
                return [
                    {value: glosaEmpleador.dniEmpleador},
                    {value: glosaEmpleador.npoliza ? glosaEmpleador.npoliza : ''},
                    {value: glosaEmpleador.estadoPoliza ? glosaEmpleador.estadoPoliza : ''},
                    {value: glosaEmpleador.nombreEmpleador ? glosaEmpleador.nombreEmpleador : ''},
                    {value: datosServicio ? datosServicio.nombre : ''},
                    {value: glosaEmpleador.codigoServicio},
                    {value: glosaEmpleador.consecutivo},
                    {value: (glosaEmpleador.fechaOperacion).replace(/\//gi,'-')},
                    {value: glosaEmpleador.glosaBloqueante ? glosaEmpleador.glosaBloqueante : 'N/A'},
                    {value: glosaEmpleador.codigoGlosa ? glosaEmpleador.codigoGlosa : ''},
                    {value: glosaEmpleador.descripcionGlosa ? glosaEmpleador.descripcionGlosa : ''},
                    {value: glosaEmpleador.detalleGlosa ? glosaEmpleador.detalleGlosa : ''},
                    {value: glosaEmpleador.respuestaSat ? glosaEmpleador.respuestaSat : ''},
                    {value: respuestaGlosaGestion.dniUsuarioGestion},
                    {value: respuestaGlosaGestion.observacionGestion ? respuestaGlosaGestion.observacionGestion : ''},
                    {value: respuestaGlosaGestion.codigoProceso ? `${obtenerProcesoGestion(respuestaGlosaGestion.codigoProceso).nombreProceso}` : ''},
                    {value: mensajePeticion ? JSON.stringify(mensajePeticion) : ''},
                    {value: respuestaGlosaGestion.codigoRespuesta},
                    {value: respuestaGlosaGestion.mensajeRespuesta}
                ];
            } else {
                return [
                    {value: glosaEmpleador.dniEmpleador},
                    {value: glosaEmpleador.npoliza ? glosaEmpleador.npoliza : ''},
                    {value: glosaEmpleador.estadoPoliza ? glosaEmpleador.estadoPoliza : ''},
                    {value: datosServicio ? datosServicio.nombre : ''},
                    {value: glosaEmpleador.codigoServicio},
                    {value: glosaEmpleador.consecutivo},
                    {value: (glosaEmpleador.fechaOperacion).replace(/\//gi,'-')},
                    {value: glosaEmpleador.glosaBloqueante ? glosaEmpleador.glosaBloqueante : 'N/A'},
                    {value: glosaEmpleador.codigoGlosa ? glosaEmpleador.codigoGlosa : ''},
                    {value: glosaEmpleador.descripcionGlosa ? glosaEmpleador.descripcionGlosa : ''},
                    {value: glosaEmpleador.detalleGlosa ? glosaEmpleador.detalleGlosa : ''},
                    {value: glosaEmpleador.respuestaSat ? glosaEmpleador.respuestaSat : ''},
                    {value: respuestaGlosaGestion.dniUsuarioGestion},
                    {value: respuestaGlosaGestion.observacionGestion ? respuestaGlosaGestion.observacionGestion : ''},
                    {value: respuestaGlosaGestion.codigoProceso ? `${obtenerProcesoGestion(respuestaGlosaGestion.codigoProceso).nombreProceso}` : ''},
                    {value: mensajePeticion ? JSON.stringify(mensajePeticion) : ''},
                    {value: respuestaGlosaGestion.codigoRespuesta},
                    {value: respuestaGlosaGestion.mensajeRespuesta}
                ];
            }
            
        }
    );

    /*Datos para generar el XLS*/
    const datosLibrosXLS: LibroDocumentoXLS[] = [{
        nombreLibro: libroGlosas,
        cabecera: cabeceraRespuestaGestionGlosas(tipoGlosa),
        datos: datosGlosas,
    }];

    return crearPlantillaXLS(librosXLS, datosLibrosXLS);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/modelo/RespuestaGestionGlosasXLS.ts